import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { nameize } from '@ltvco/refresh-lib/utils';

import { ContactReportSummaryData } from '../DataTypes/SummaryTypes';

interface ContactReportRendererProps {
  data: ContactReportSummaryData;
}

export const ContactReportRenderer = ({ data }: ContactReportRendererProps) => {
  return (
    <Stack spacing={2}>
      <Text>
        Here's a professional contact summary for{' '}
        <span style={{ fontWeight: 700 }}>{data.personName}</span>:
      </Text>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Summary</span>
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Job Title:</span>{' '}
          {nameize(data?.jobs?.[0]?.title) || '-'}
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Company:</span>{' '}
          {nameize(data?.jobs?.[0]?.company) || '-'}
        </Text>
        <Text>
          <span style={{ fontWeight: 700 }}>Aliases :</span>{' '}
          {data.aliases?.length > 0
            ? data.aliases.map((alias) => nameize(alias)).join(', ')
            : '-'}
        </Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Contact Info</span>
        </Text>
        <Text>📞 {data.phone || '-'}</Text>
        <Text>✉️ {data.email || '-'}</Text>
        <Text>🏠 {data.address || '-'}</Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Social Media</span>
        </Text>
        {data.social?.length > 0
          ? data.social.map((social) => (
              <Text key={social.user_id}>{social.user_id}</Text>
            ))
          : '-'}
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Employment History</span>
        </Text>
        {data.jobs?.length > 0
          ? data.jobs.map((job) => (
              <Text key={job.title}>
                {nameize(job.title)} at {nameize(job.company)}
              </Text>
            ))
          : '-'}
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <span style={{ fontWeight: 700 }}>Education</span>
        </Text>
        <Text>{nameize(data.education) || '-'}</Text>
      </Stack>
    </Stack>
  );
};
